import { colors, getBorderRadius, getSpacing, mainFont } from '@cabonline/ui-shared';
import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const shake = keyframes`
  0% { transform: rotate(0deg); }
  15% { transform: rotate(14deg); }
  30% { transform: rotate(-12deg); }
  45% { transform: rotate(10deg); }
  60% { transform: rotate(-8deg); }
  75% { transform: rotate(4deg); }
  90% { transform: rotate(-2deg); }
  100% { transform: rotate(0deg); }
`;

export const StyledBellWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const StyledBellButton = styled.button<{ hasNew?: boolean }>`
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  padding: ${getSpacing('xxs')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${getBorderRadius('m')};
  transform-origin: 50% 0;

  ${({ hasNew }) =>
    hasNew &&
    css`
      animation: ${shake} 0.6s ease-in-out;
      animation-iteration-count: 3;
    `}

  &:hover {
    background-color: ${colors.blackHover};
  }

  &:focus {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const StyledBadge = styled.span`
  position: absolute;
  top: 0;
  right: -2px;
  background-color: ${colors.lightRed};
  color: ${colors.black};
  font-size: 10px;
  font-weight: 800;
  font-family: ${mainFont};
  min-width: 17px;
  height: 17px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  aspect-ratio: 1;
  pointer-events: none;
`;

export const StyledPopover = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background-color: ${colors.white};
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: ${getBorderRadius('m')};
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  min-width: 280px;
  padding: ${getSpacing('s')};
  margin-top: 4px;
  white-space: nowrap;
`;

export const StyledPopoverRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${getSpacing('xs')} 0;
`;

export const StyledPopoverBadge = styled.span`
  background-color: ${colors.primary};
  color: ${colors.white};
  font-size: 14px;
  font-weight: 700;
  font-family: ${mainFont};
  min-width: 24px;
  height: 24px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
`;

export const StyledViewAllButton = styled.button`
  width: 100%;
  margin-top: ${getSpacing('xs')};
  padding: ${getSpacing('xs')} ${getSpacing('m')};
  background-color: ${colors.black};
  color: ${colors.white};
  border: none;
  border-radius: ${getBorderRadius('m')};
  font-family: ${mainFont};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  &:focus {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;
